<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let history;

  function clickSearch(event, search, index) {
    if (event.metaKey || event.ctrlKey) {
      dispatch("deleteSearch", { index });
      return;
    }

    switch (search.type) {
      case "single":
        dispatch("filterNote", {
          id: search.value,
          searchTerm: search.term,
          index,
        });
        break;
      case "all":
        dispatch("filterNotes", {
          noteIds: search.value,
          searchTerm: search.term,
          index,
        });
        break;
      case "tag":
        dispatch("filterTag", { tag: search.value, index });
        break;
    }
  }
</script>

<section>
  {#if history.length}
    <div class="search-history">
      <p>Recent searches</p>
      <ul>
        {#each history as search, index}
          <li>
            <button
              class:active={search.active}
              on:click={(event) => clickSearch(event, search, index)}
            >
              <div class="label">{search.type}</div>
              <div class="value">
                {search.type === "tag" ? search.value : search.term}
              </div>
            </button>
          </li>
        {/each}
      </ul>
    </div>
  {/if}
</section>

<style>
  .search-history {
    position: relative;
    margin-bottom: 1rem;
  }

  .search-history:after {
    content: "";
    position: absolute;
    width: 55px;
    height: 100%;
    top: 0;
    right: 0;
    background: linear-gradient(
      270deg,
      rgb(28, 30, 32) 0%,
      rgba(28, 30, 32, 0.1) 100%
    );
  }

  .search-history > p {
    font-size: 0.75rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #999;
  }

  .search-history ul {
    display: flex;
    overflow-x: auto;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .search-history li {
    margin-right: 1rem;
  }

  .search-history button {
    display: block;
    text-decoration: none;
    border: 1px solid #999;
    color: #ccc;
    padding: 0.25rem 0.4rem;
    border-radius: 4px;
    max-height: none;
    text-align: left;
    white-space: nowrap;
  }

  .search-history button.active {
    background-color: #ccc;
    color: #1c1e20;
  }

  .label {
    font-size: 0.65rem;
    font-weight: bold;
  }

  .value {
    font-size: 0.875rem;
    font-style: italic;
    letter-spacing: 0.3px;
    max-width: 15ch;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
